import type { CompareResult } from "@/features/widgets/components/Comparison/ComparisonTable.tsx";
import { Product } from "@/features/widgets/components/Comparison/types/ComparisonTypes";

// The backend comparison data doesn't include fields like `image` (they're
// only known client-side, from the widget's own DOM attributes), so merge
// each product with its backend counterpart rather than using either alone.
export const mergeProductData = (product: Product, data: CompareResult | null): Product => {
  const match = data?.products.find(item => item.url === product.url);
  return { ...match, ...product };
}
